import { Controller } from "@hotwired/stimulus";
import plausible from "../plausible.js";

export default class extends Controller {
  connect() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
    this.plausible = plausible();

    let modalIds = [];
    let modals = document.querySelectorAll(".modal-content");

    if (modals) {
      modals.forEach((elm) => {
        if (modalIds.indexOf("#" + elm.id) !== -1) {
          return;
        }
        modalIds.push("#" + elm.id);
      });
    }

    document.addEventListener("click", (evt) => {
      let target = evt.target.closest("a") || evt.target;
      let id = target.getAttribute("href");

      if (modalIds.includes(id)) {
        if (!document.body.classList.contains("swiping")) {
          let modalContentElm = document.querySelector(id);

          this.addModal(
            modalContentElm.innerHTML,
            modalContentElm.dataset.style
          );
        }
      }

      if (id === "#chat") {
        BefareChat.open();
      }
    });
  }

  disconnect() {
    if (this.plausible) {
      this.plausible.destroy();
    }
  }

  onResize() {
    document.documentElement.style.setProperty(
      "--100vw",
      (document.documentElement.clientWidth || document.body.clientWidth) + "px"
    );
  }

  addModal(content, style) {
    this.element.insertAdjacentHTML(
      "beforeend",
      `<div class="modal modal--${style}" data-controller="modal" data-action="click->modal#maybeClose">
        <div class="modal__bg"></div>
        <button class="modal__close"></button>
        <div class="modal__content">
        ${content}
        </div>
      </div>`
    );
  }
}
